import { render, staticRenderFns } from "./TCloseModal.vue?vue&type=template&id=4f546630&scoped=true&"
import script from "./TCloseModal.vue?vue&type=script&lang=js&"
export * from "./TCloseModal.vue?vue&type=script&lang=js&"
import style0 from "./TCloseModal.vue?vue&type=style&index=0&id=4f546630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f546630",
  null
  
)

export default component.exports